/** CSV con `;` y BOM: Excel en español lo abre sin asistente de importación. */
export function csvCell(value: string): string {
    if (/[;"\n\r]/.test(value)) return `"${value.replace(/"/g, '""')}"`;
    return value;
}

export function rowsToCsv(headers: readonly string[], rows: readonly (readonly string[])[]): string {
    const lines = [headers.map(csvCell).join(';')];
    for (const row of rows) lines.push(row.map((cell) => csvCell(cell)).join(';'));
    return `\uFEFF${lines.join('\n')}`;
}
